module.exports = __webpack_public_path__ + "gif/wrong-9.gif";